import React, { useState, useEffect, useRef, useCallback } from "react";
import { formatEventDate, formatEventTime } from "../../helpers/eventDateTime";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/Loader/LoadingSpinner";
import Modal from "../../components/ImageModal/ImageModal";
import { useNavigate, useLocation } from "react-router-dom";
// import Header from "../../components/Header/Header";
import API_UTIL from "../../services/AuthIntereptor";
import "../../components/Footer/Footer.css"; // Import the updated CSS
import "./ImagePage-new.css";
import AppBar from "../../components/AppBar/AppBar";
import Footer from "../../components/Footer/Footer";
import defaultBanner from '../../media/images/defaultBanner.jpg';
import { Icons, EventCover } from "../../components/ui";

function ImagesPageNew() {
const [lastEvaluatedKey, setLastEvaluatedKey] = useState(undefined);
const [fetchTimeout, setFetchTimeout] = useState(false);
const [totalImages, setTotalImages] = useState(0);
const [clickedUrl, setClickedUrl] = useState(null);
const [clickedImgIndex, setClickedImgIndex] = useState(null);
const [clickedImgFavourite, setClickedImgFavourite] = useState(null);
const [clickedImg, setClickedImg] = useState(null);
const [images, setImages] = useState([]);
const { eventName, userId } = useParams();
const isFavouritesFetched = useRef(false);
const history = useNavigate();
const location = useLocation();
const [clientObj, setClientObj] = useState();
const [userObj,setUserObj] = useState();
const [bannerImg, setBannerImg]  = useState(defaultBanner);
const [isClaimPopupOpen, setIsClaimPopupOpen] = useState(true);
const [event, setEvent] = useState(null);
const [isPageLoading, setIsPageLoading] = useState(true);
const [hasMore, setHasMore] = useState(true);
const loader = useRef(null);
const [isGalleryLoading, setIsGalleryLoading] = useState(false);


const [breakpointColumnsObj, setBreakpointColumnsObj] = useState({
  default: calculateColumns(),
  1200: calculateColumns(),
  992: calculateColumns(),
  768: calculateColumns(),
  576: calculateColumns(),
});

useEffect(() => {
  const handleResize = () => {
    setBreakpointColumnsObj({
      default: calculateColumns(),
      1200: calculateColumns(),
      992: calculateColumns(),
      768: calculateColumns(),
      576: calculateColumns(),
    });
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  if (eventName) {
    fetchEventData(eventName);
  }
}, [eventName]);



  // Add the promotional image at the beginning of the gallery
  const [promoImage] = useState({
    thumbnail: "https://imageshieldpromotions.s3.us-east-1.amazonaws.com/SAWIB25imageshieldpromotionCover.jpg", // Image URL
    original: "https://imageshieldpromotions.s3.us-east-1.amazonaws.com/SAWIB25imageshieldpromotion.pdf", // PDF URL to open on click
    isPromo: true, // Special flag to identify promo image
    isPDF: false // Show as image, not PDF
  });

  // Combine promo image with regular images
  // const allImages = [promoImage, ...images];

  // const handleImageClick = (imageData, index) => {
  //   if (imageData.isPromo) {
  //     // Open ImageShield website in a new tab for promo image
  //     window.open(imageData.original, '_blank');
  //   } else {
  //     // Regular image click handling
  //     setClickedImg(imageData.thumbnail);
  //     setClickedImgIndex(index);
  //     setClickedImgFavourite(imageData.isFavourites);
  //     setClickedUrl(imageData.original);
  //     window.history.pushState({ id: 1 }, null, "?image=" + `${imageData.original.split('/').pop()}`);
  //   }
  // };



const fetchEventData = async (foldername) => {
  setIsPageLoading(true);
  try {
    const response = await API_UTIL.get(`/getEventDetailsByFolderName/${foldername}`);
    setEvent(response.data);
    console.log(response);

    fetchClientDetails(response.data);

    // Check the event date and time condition before fetching images
    // if (!response.data.event_date || new Date(response.data.event_date) < new Date()) {
      fetchAllImages(); // Fetch images if the date is not set or the date has passed
    // }
  } catch (error) {
    console.error("Error fetching event data:", error);
  } finally {
    setIsPageLoading(false);
  }
};


const handleImageClick = (imageData, index) => {

  if (imageData.isPromo) {
    window.open(imageData.original, '_blank');
    return;
  }
  console.log("Image clicked");
  setClickedImg(imageData.thumbnail);
  setClickedImgIndex(index);
  setClickedImgFavourite(imageData.isFavourites);
  setClickedUrl(imageData.original);
  window.history.pushState({ id: 1 }, null, "?image=" + `${imageData.original.split('/').pop()}`);
};

const fetchFavouriteImages = async () => {
  setIsGalleryLoading(true);
  try {
    const response = await API_UTIL.post(`/images-new/${eventName}/${userId}`, {
      isFavourites: true,
    });

    if (response.status === 200) {
      setUserObj(response.data.userObj);

      const favoriteImages = response.data.images.map((img) => ({
        original: img.url,
        thumbnail: img.thumbnailUrl,
        isFavourites: true,
      }));

      addUniqueImages(favoriteImages);

      if (!totalImages) {
        setTotalImages(response.data.totalImages);
      }

      await fetchImages(favoriteImages); // Pass favorite images to fetchImages
    } else {
      throw new Error("Failed to fetch images");
    }
  } catch (error) {
    if (error?.response?.status === 700) {
      history(`/login/${eventName}`, { state: { from: location } });
    }
    console.error("Error fetching images:", error);
  } finally {
    setIsGalleryLoading(false);
  }
};

const addUniqueImages = (newImages) => {
  setImages((prevImages) => {
    // Create a Set of existing image URLs for quick lookup
    const existingUrls = new Set(prevImages.map((img) => img.original));

    // Filter out new images that already exist in the current state
    const uniqueImages = newImages.filter((img) => !existingUrls.has(img.original));

    // Return the combined array of previous images and unique new images
    return [...prevImages, ...uniqueImages];
  });
};

const fetchClientDetails = async (event) => {

  try {
    const response = await API_UTIL.get(`/getClientDetailsByEventId/${event.event_id}`);
    if (response.status === 200) {
      setClientObj(response.data);
      await fetchPortfolioImages(response.data.user_name);
    } else {
      throw new Error("Failed to fetch client Details");
    }
  } catch (error) {
    console.error("Error fetching user thumbnails:", error);
  }
};


 const fetchImages = async (favoriteImages = []) => {
if (images.length === 0) setIsGalleryLoading(true);
try {
  const response = await API_UTIL.post(`/images-new/${eventName}/${userId}`, {
    isFavourites: false,
    lastEvaluatedKey: lastEvaluatedKey,
  });

  if (response.status === 200) {
    // Filter out favorite images
    const favoriteImageUrls = favoriteImages.map((img) => img.original);
    const nonFavImages = response.data.images.filter(
      (img) => !favoriteImageUrls.includes(img.url)
    );

    const formattedImages = nonFavImages.map((img) => ({
      original: img.url,
      thumbnail: img.thumbnailUrl,
      isFavourites: false,
    }));
    addUniqueImages(formattedImages);

    // setImages((prevImages) => [...prevImages, ...formattedImages]);
    console.log(response.data.lastEvaluatedKey);
    setLastEvaluatedKey(response.data.lastEvaluatedKey);

    if (!totalImages) {
      setTotalImages(response.data.totalImages);
    }

    if (images.length >= totalImages) {
      setIsGalleryLoading(false); // Stop fetching more images when all images are fetched
    }
  } else {
    throw new Error("Failed to fetch images");
  }
} catch (error) {
  console.error("Error fetching images:", error);
} finally {
  setIsGalleryLoading(false);
}
};




// NOTE: Pagination is driven by the `lastEvaluatedKey` effect below, which
// auto-loads each subsequent page until the backend returns no more keys.
// A previous IntersectionObserver here re-subscribed on every render (because
// `fetchImages` is a new function each render) and `hasMore` was never cleared,
// which caused an infinite fetch loop and made the empty-state flicker. Removed.


const fetchPortfolioImages = async (userName) => {
  console.log('Fetching portfolioImage with username:', userName);
  if (userName) {
    try {
      const response = await API_UTIL.get(`/getBannerImage/${userName}`);
      if (response.data && response.data.imageUrl) {
        console.log('[fetchPortfolioImages] Response from bannerImage url: ', response.data.imageUrl);
        const formattedUrl = encodeURIWithPlus(response.data.imageUrl);
        console.log('[fetchPortfolioImages] Formatted url: ', formattedUrl);
        setBannerImg(`${formattedUrl}?t=${Date.now()}`);
      } else {
        setBannerImg(defaultBanner);
      }
    } catch (error) {
      console.error('Error fetching banner image:', error);
      setBannerImg(defaultBanner);
    }
  } else {
    setBannerImg(defaultBanner);
  }
};

const encodeURIWithPlus = (uri) => {
  return uri.replace(/ /g, '+');
};


const fetchAllImages = async () => {
  if(userId !== "upcoming"){
    fetchFavouriteImages()
  }

};



useEffect(() => {
  if (totalImages === 0) {
    setFetchTimeout(true);
  }
}, [totalImages]);

useEffect(() => {
  if (lastEvaluatedKey) {
    console.log("call");
    fetchImages();
  }
  console.log(images.length);
}, [lastEvaluatedKey]);

const handleBackButton = () => {
  // Check if the navigation was caused by the back button
  setClickedImg(null);
};
useEffect(() => {
  // Add event listener for the popstate event on the window object
  window.addEventListener("popstate", handleBackButton);

  // Clean up the event listener when the component unmounts
  return () => {
    window.removeEventListener("popstate", handleBackButton);
  };
}, []);
useEffect(() => {
  const handleBackGesture = (event) => {
    // Check if the user performed a back gesture
    if (event.deltaX > 50) {
      // Adjust threshold as needed
      setClickedImg(null);
      console.log("back gesture detected");

      // Add your custom logic here, such as navigating back
      history.goBack(); // Navigate back using React Router
    }
  };

  window.addEventListener("touchmove", handleBackGesture);

  return () => {
    window.removeEventListener("touchmove", handleBackGesture);
  };
}, [history]);

useEffect(() => {
  const disablePinchZoom = (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  };
  document.addEventListener("touchmove", disablePinchZoom, {
    passive: false,
  });
  return () => {
    document.removeEventListener("touchmove", disablePinchZoom);
  };
}, []);

useEffect(() => {
  function touchHandler(event) {
    if (event.touches.length > 1) {
      //the event is multi-touch
      //you can then prevent the behavior
      event.preventDefault();
    }
  }
  window.addEventListener("touchstart", touchHandler, { passive: false });
  return () => {
    window.removeEventListener("touchstart",touchHandler);
  }
}, []);

const handleFavourite = async (index, imageUrl, isFav) => {
  const imageIndex = images.findIndex((image) => image.original === imageUrl);
  const targetIndex = imageIndex >= 0 ? imageIndex : index;

  setImages((currentImages) =>
    currentImages.map((image, currentIndex) =>
      currentIndex === targetIndex ? { ...image, isFavourites: isFav } : image
    )
  );

  await API_UTIL.post("/setFavouritesNew", {
    imageUrl,
    userId,
    isFav,
  });
};

const toggleFavourite = (index) => {
  const isFav = !images[index].isFavourites;
  handleFavourite(index, images[index].original, isFav);
};
const closeClaimPopup = () => {
  setIsClaimPopupOpen(false);
};
const formatEventName = (name) => {
  if (!name) return '';
  let event = name.replace(/_/g, ' ');
  return event.trim();
};

// const breakpointColumnsObj = {
//   default: 5,  // 6 columns for large screens (default)
//   1200: 5,     // 6 columns for screens 1200px and above
//   992: 5,      // 6 columns for screens between 992px and 1200px (laptops)
//   768: 3,      // 3 columns for screens between 768px and 992px (tablets)
//   576: 3,      // 3 columns for screens 576px and below (mobile)
// };


const eventReturnTo = location.state?.returnTo || '/event?tab=attended';

return (
  <div className="bg-white text-slate-900 min-h-screen flex flex-col">
  <AppBar />

  {/* Back to events */}
  <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 pt-4">
    <button
      onClick={() => history(eventReturnTo)}
      className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900 transition"
    >
      <Icons.ChevronLeft className="w-4 h-4" />
      Back to events
    </button>
  </div>

  {/* Hero band */}
  <div className="relative h-56 sm:h-72 overflow-hidden border-b border-gray-200 mt-3">
    <EventCover
      src={event?.event_image || (bannerImg && bannerImg !== defaultBanner ? bannerImg : undefined)}
      label={formatEventName(event?.event_name)}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/40" />
    <div className="absolute inset-0 grid place-items-center text-center text-white px-4">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight drop-shadow">
          {formatEventName(event?.event_name)}
        </h1>
        {(clientObj?.social_media?.youtube ||
          clientObj?.social_media?.instagram ||
          clientObj?.social_media?.facebook) && (
          <div className="mt-3 flex items-center justify-center gap-3 text-white/90">
            {clientObj?.social_media?.youtube && (
              <a href={clientObj.social_media.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-white" aria-label="YouTube">
                <Icons.Youtube className="w-5 h-5" />
              </a>
            )}
            {clientObj?.social_media?.instagram && (
              <a href={clientObj.social_media.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-white" aria-label="Instagram">
                <Icons.Instagram className="w-5 h-5" />
              </a>
            )}
            {clientObj?.social_media?.facebook && (
              <a href={clientObj.social_media.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-white" aria-label="Facebook">
                <Icons.Facebook className="w-5 h-5" />
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  </div>

  <div className="fade-in max-w-[1400px] mx-auto w-full px-4 sm:px-6 py-8 grid grid-cols-1 lg:grid-cols-4 gap-6 flex-1">
    {event && (
    <aside className="lg:col-span-1">
      <div className="lg:sticky lg:top-20 bg-white border border-gray-200 rounded-xl p-5 shadow-card">
        <div className="aspect-[5/3] rounded-lg overflow-hidden border border-gray-200 bg-gray-50">
          <img src={event?.event_image} alt="Event" className="w-full h-full object-cover" />
        </div>
        <h2 className="mt-4 font-bold text-brand-600 text-lg leading-tight">{formatEventName(event?.event_name)}</h2>
        <div className="mt-3 space-y-2 text-sm text-slate-600">
          {formatEventDate(event) && (
            <div className="flex items-center gap-2">
              <Icons.Calendar className="w-4 h-4 text-brand-600 shrink-0" />
              <span>{formatEventDate(event)}</span>
            </div>
          )}
          {formatEventTime(event) && (
            <div className="flex items-center gap-2">
              <Icons.Clock className="w-4 h-4 text-brand-600 shrink-0" />
              <span>{formatEventTime(event)}</span>
            </div>
          )}
          <div className="flex items-start gap-2">
            <Icons.Pin className="w-4 h-4 text-brand-600 mt-0.5 shrink-0" />
            <span className="leading-snug">{event?.event_location || 'Location not set'}</span>
          </div>
          <div className="flex items-start gap-2">
            <Icons.Message className="w-4 h-4 text-brand-600 mt-0.5 shrink-0" />
            <span className="leading-snug">{event?.invitation_note || 'Invitation Note not set'}</span>
          </div>
        </div>
      </div>
    </aside>
    )}
    <main className={event ? "lg:col-span-3" : "lg:col-span-4"}>
    {isGalleryLoading ? (
        <div className="grid place-items-center py-24">
          <LoadingSpinner color="#2563eb" />
        </div>
      ) : (!images.length && totalImages === 0) ? (
        <div className="bg-white border border-gray-200 rounded-xl p-10 text-center shadow-card">
          <div className="w-14 h-14 rounded-full bg-brand-50 border border-brand-100 text-brand-600 grid place-items-center mx-auto">
            <Icons.Check className="w-7 h-7" />
          </div>
          <h2 className="mt-5 text-xl sm:text-2xl font-bold text-slate-900">
            Congratulations! You have successfully registered for the event.
          </h2>
          <p className="mt-3 text-slate-500 max-w-xl mx-auto leading-relaxed">
            We are currently uploading your event photos to the ImageShield® AI platform. You will
            receive an SMS notification once your photos are available.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {images.map((imageData, index) => (
            <div
              key={index}
              className="relative rounded-xl overflow-hidden bg-gray-100 border border-gray-200 group cursor-pointer aspect-[4/3]"
            >
              <img
                src={imageData.thumbnail}
                alt={`img ${index}`}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                onClick={() => handleImageClick(imageData, index)}
              />
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFavourite(index);
                }}
                className="absolute bottom-2 right-2 w-8 h-8 grid place-items-center bg-white/95 backdrop-blur rounded-full border border-gray-200 shadow-soft opacity-90 group-hover:opacity-100 transition"
                aria-label={imageData.isFavourites ? "Unfavourite" : "Favourite"}
              >
                <Icons.Heart data-key={index} filled={imageData.isFavourites} className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
      <div ref={loader} style={{ height: '20px', marginTop: '20px' }} />
    </main>
  </div>

  {clickedImg && (
    <div className="fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-black z-[1000] flex items-center justify-center">
    <Modal
                  clickedImg={clickedImg}
                  clickedImgIndex={clickedImgIndex}
                  clickedImgFavourite={clickedImgFavourite}
                  setClickedImg={setClickedImg}
                  clickedUrl={clickedUrl}
                  handleBackButton={handleBackButton}
                  handleFavourite={handleFavourite}
                  images={images} // Pass the images array to Modal
                />
    </div>
  )}
  < Footer/>
</div>
);
}

const calculateColumns = () => {
const width = window.innerWidth;
if (width >= 1200) {
  return 5;
} else if (width >= 992) {
  return 5;
} else if (width >= 768) {
  return 4;
} else {
  return 3;
}
};

export default ImagesPageNew;
